var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', {
    attrs: {
      "value": _vm.value,
      "items": _vm.displayItems,
      "loading": _vm.loading,
      "label": _vm.label,
      "disabled": _vm.disabled,
      "clearable": _vm.clearable,
      "required": _vm.required,
      "multiple": _vm.multiple,
      "chips": _vm.multiple,
      "deletable-chips": _vm.multiple,
      "small-chips": _vm.multiple,
      "item-text": "text",
      "item-value": "value",
      "prepend-inner-icon": _vm.icon ? _vm.iconName(_vm.icon) : null,
      "dense": _vm.dense,
      "outlined": _vm.outlined,
      "flat": _vm.flat,
      "hide-details": _vm.hideDetails,
      "background-color": _vm.backgroundColor,
      "menu-props": {
        closeOnContentClick: !_vm.multiple
      }
    },
    on: {
      "input": _vm.onInput
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }